import { ContentSection } from "../layout/ContentSection"
import { Typography } from "@mui/material"

export const Miscellaneous = () => (
    <ContentSection title="Miscellaneous">
        <Typography variant="body1">
            • Interests: Minimalism, Getting Things Done (GTD), Yoga, Workout, Mathematics, Physics
        </Typography>
    </ContentSection>
)
